<vs-app-page
  [config]="{
    title: 'Settings',
    icon: 'settings-01',
    description: 'Here you will find the settings for your organization.'
  }"
>
  <vs-tab-nav
    *vsLet="tabs$ | async as tabs"
    slot="sticky"
    theme="primary"
    [config]="{ items: tabs ?? [] }"
  ></vs-tab-nav>

  <router-outlet></router-outlet>
</vs-app-page>
